import type { HeySynclyChatMode, HeySynclyStudioItemType } from './types';

export const getHeySynclyItemTypeByChatMode = (
  chatMode: HeySynclyChatMode,
): HeySynclyStudioItemType | null => {
  if (chatMode === 'REPORT') return 'CUSTOM_DOCUMENT';
  return null;
};
